<template>
  <div>
    <Loading v-if="isLoading" />
    <div v-else>
      <h5>Daily lists</h5>
      <vs-row>
        <ListCard
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.eodreport.show')"
          title="End of Day Report (legacy)"
          description="EOD is the daily overview of how the night went, taking into consideration any financial KPI's, notes regarding incidents and evaluation of various elements"
          :imageUrl="require('@/assets/images/lists/end-of-day.png')"
          :onClick="() => checklistClicked('eodReports')"
        />
        <ListCard
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.eodreport.show')"
          title="End of day Report"
          description="EOD is the daily overview of how the night went, taking into consideration any financial KPI's, notes regarding incidents and evaluation of various elements"
          :imageUrl="require('@/assets/images/lists/end-of-day.png')"
          :onClick="() => checklistClicked('eodSessions')"
        />
        <ListCard
          v-for="list in getListsByType('FireProtectionMeasures')"
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.fireprotectionmeasures.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />
      </vs-row>

      <vs-divider />

      <h5 class="my-3">Venue visits</h5>
      <vs-row>
        <ListCard
          v-for="list in getListsByType('VenueVisitLight')"
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.venuevisitlight.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />
        <ListCard
          v-for="list in getListsByType('BarsWithRestaurantsThorough')"
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.barswithrestaurantsthorough.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />
        <ListCard
          v-for="list in getListsByType('BarsAndNightclubsThorough')"
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.barsandnightclubsthorough.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />
        <ListCard
          v-for="list in getListsByType('CompetitorVisit')"
          v-if="hasPermission('vp.vp.lifelists.competitorvisit.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />
      </vs-row>

      <vs-divider />

      <h5 class="my-3">Maintenance reviews & Old Venue Visits</h5>
      <vs-row>
        <ListCard
          v-for="list in getListsByType('MaintenanceReviewLight')"
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.maintenancereviewlight.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />
        <ListCard
          v-for="list in getListsByType('MaintenanceReviewThorough')"
          v-if="hasPermissionForActiveVenue('vp.vp.lifelists.maintenancereviewthorough.show')"
          :key="list.id"
          :title="list.title"
          :description="list.description"
          :imageUrl="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
          :onClick="() => listClicked(list.id)"
        />

        <ListCard
          v-if="hasPermissionForActiveVenue('vp.vp.lists.maintenancereviews.show')"
          title="Maintenance Review (old)"
          description="The 4 areas in our stores we want to ensure a high and attractive level of maintenance and order are:
 
Facade (This is our display window and included in a negotiation with the landlord)

Venue (This is where our guests go. It is important that it always looks good)

Warehouse (Staff work here. The more orderly and neat it is, the more professional we appear to our staff. We generally also have more control over the venue)

Backyard and garbage area (This is included in a negotiation with the landlord and is often something that can create peace and order with neighbors, but also the opposite).

It is possible that other area defined by RMs. Could be stairways or similar.
 
The total score is assessed based on the 4 areas above, each with their own in-depth points.
 
The grading scale is from 1-4. Given 4, it 100% lives up to our expectations. A 5 can be given in cases where it is simply outstanding and corresponds to 125%.

Our expectation and objective is that our stores must never fall below an overall average of 3.5."
          :imageUrl="require(`@/assets/images/lists/maintenance-old.png`)"
          :onClick="() => checklistClicked('oldMaintenanceReviews')"
        />
        <ListCard
          v-if="hasPermissionForActiveVenue('vp.vp.lists.venuevisits.show')"
          title="Venue Visit (old)"
          description="Venue Visit Light is used as a regular scoring tool to measure how the venue is performing. It is a light version with fewer questions and should take about 15-20 minutes to fill out."
          :imageUrl="require(`@/assets/images/lists/venue-visits-light-old.png`)"
          :onClick="() => checklistClicked('oldVenueVisits')"
        />
      </vs-row>

      <template v-if="otherListsWithPermission.length > 0">
        <vs-divider />

        <h5 class="my-3">Other</h5>

        <vs-row>
          <ListCard
            v-for="list in otherListsWithPermission"
            :key="list.id"
            :title="list.title"
            :description="list.description"
            :imageUrl="list.imageUrl"
            :onClick="() => listClicked(list.id)"
          /> </vs-row
      ></template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ListCard from "./components/ListCard.vue";

export default {
  components: { ListCard },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      latestListsForVenue: "lists/latestListsForVenue",
      isLoading: "lists/isLoading",
      activeVenue: "venues/activeVenue"
    }),

    otherListsWithPermission() {
      console.log("TEST", this.latestListsForVenue);

      const otherCategory = this.latestListsForVenue.find(e => e.category === "Other");
      if (!otherCategory) return [];

      return otherCategory.lists.filter(list => this.hasPermissionForActiveVenue(list.idamPermissionViewSubmissions));
    }
  },
  methods: {
    getListsByType(listType) {
      // Flatten listCategories and filter all lists that match
      // Support both exact match and "startsWith" pattern for types with numbered variants
      return this.latestListsForVenue
        .map(categoryGroup => categoryGroup.lists)
        .flat()
        .filter(list => list.type === listType || list.type.startsWith(listType));
    },
    listTypeToImgName(listType) {
      // Handle types that start with a base type (e.g., FireProtectionMeasures2, FireProtectionMeasures3)
      if (listType.startsWith("FireProtectionMeasures")) {
        return "fire.png";
      }
      
      switch (listType) {
        case "VenueVisitLight":
          return "venue visits light.png";
        case "BarsWithRestaurantsThorough":
          return "food thorough.png";
        case "BarsAndNightclubsThorough":
          return "nightclub and bars thorough.png";
        case "CompetitorVisit":
          return "competitor.png";
        case "MaintenanceReviewLight":
          return "maintenance.png";
        case "MaintenanceReviewThorough":
          return "maintenance thorough.png";
        default:
          return "ERROR";
      }
    },
    listClicked(listId) {
      this.$router
        .push({
          name: "list-submissions",
          params: { listId: listId }
        })
        .catch(() => {});
    },
    checklistClicked(type) {
      this.$router
        .push({
          name: type
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.$store.dispatch("lists/getLatestListsForVenue", this.activeVenue.venueId);
    this.latestListsForVenue;
  }
};
</script>

<style lang="scss">
.card-image-custom {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-repeat: no-repeat;
  background-size: cover;
  height: 140px;
}
.card-image-background-color {
  background-image: linear-gradient(to right, rgba(var(--vs-primary), 0.7), rgba(var(--vs-primary), 1));
}
</style>